import {CategoryFilterEnum} from 'domain/usecases';
import {ExamsRequestsFlowEnum} from './types';

const EXAM_REQUESTS_LIST_SIZE = 20;

const EXAM_REQUESTS_STATUS: Record<ExamsRequestsFlowEnum, string> = {
	[ExamsRequestsFlowEnum.RELEASED]: `${CategoryFilterEnum.RELEASED}, ${CategoryFilterEnum.PENDING}`,
	[ExamsRequestsFlowEnum.WAITING]: CategoryFilterEnum.WAITING,
};

export {EXAM_REQUESTS_LIST_SIZE, EXAM_REQUESTS_STATUS};
